import { LayoutGenerator } from "dependencies/emptyLayout/utils/layoutGenerator"
import { Tabs } from "materials/tabs/menus/model"
import { Button } from "materials/button/menus/model"
import { Image } from "materials/image/menus/model"
import { navMenu } from "materials/navMenu/menus/model"

/**
 * 门户登陆默认配置数据
 */
// 登录样式
export const loginHome = [
  {
    styleId: 1,
    isSystemComponent: true,
    isDefaultComponent: true,
    isCustomComponent: true, //定制组件
    isIndependenceComponent: true ,//toolbar-option-components 没有单独的设置项
    name: "登录组件",
    width: 200,
    height: 36,
    borderWidth: 0,
    styleName: "自由布局",
    thumbnail: require("../../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["loginLayoutComponent"],
    titleOptions: [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: false,
            type: "classification",
            options: new Tabs({
              elementInLayoutId: 5,
              hoverMaxTabLength: 5,
              tabWidth: 60,
              borderColor: "rgba(255,255,255,1)",
              hoverBorderColor: "rgba(255,255,255,1)",
              tabsList: [
                { name: "未登录", content: "未登录" },
                { name: "登录后", content: "登录后" }
              ]
            })
          },
          {}
        ]
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Button({
                  loginType: "loginBtn",
                  elementInLayoutId: 0,
                  width: 96,
                  height: 36,
                  top: 0,
                  left: 0,
                  content: "登录",
                  iconSrc: "4E6EE877E0E703DD",
                  iconType: "icon",
                  iconColor: "rgba(255,255,255,1)",
                  iconMargin: 6,
                  iconWidth: 18,
                  borderTopLeftRadius: 99,
                  borderTopRightRadius: 99,
                  borderBottomLeftRadius: 99,
                  borderBottomRightRadius: 99
                }),
                // new Button({
                //   loginType: "registerBtn",
                //   elementInLayoutId: 1,
                //   width: 96,
                //   height: 36,
                //   top: 0,
                //   left: 100,
                //   content: "注册",
                //   iconSrc: "4E6EE877E0E703DD",
                //   iconType: "icon",
                //   iconColor: "rgba(255,255,255,1)",
                //   iconMargin: 6,
                //   iconWidth: 18,
                //   borderTopLeftRadius: 99,
                //   borderTopRightRadius: 99,
                //   borderBottomLeftRadius: 99,
                //   borderBottomRightRadius: 99
                // })
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Image({
                  loginType: "loginImage",
                  elementInLayoutId: 2,
                  width: 36,
                  height: 36,
                  top: 0,
                  left: 0,
                  borderTypeFlag:1,
                  innerElement: "imageComponent",
                  shapeType: "round",
                  borderRadius:"50%",
                  borderTopLeftRadius: "50%",
                  borderTopRightRadius: "50%",
                  borderBottomLeftRadius: "50%",
                  borderBottomRightRadius: "50%"
                }),
                new navMenu({
                  loginType: "loginName",
                  elementInLayoutId: 4,
                  width: 128,
                  height: 36,
                  top: 0,
                  left: 44,
                  fontSize: 16,
                  lineHeight: 36,
                  liLineHeight: 36,
                  activeLineHeight: 36,
                  hoverLineHeight: 36,
                  selectFontColor: "rgba(0,0,0,.8)",
                  activeFontColor: "rgba(0,0,0,.8)",
                  hoverFontColor: "rgba(0,0,0,.8)",
                  hoverBgColor: "rgba(0,0,0,0)",
                  activeBgColor: "rgba(0,0,0,0)",
                  selectBgColor: "rgba(0,0,0,0)",
                  topNavPaddingLeft: 0,
                  topNavBgColor: "rgba(255,255,255,0)",
                  bgColor: "rgba(255,255,255,0)",
                  selectOptions: [
                    {
                      label: "张三",
                      value: "https://www.chaoxing.com/",
                      children: [
                        {
                          label: "进入空间",
                          value: "http://i.chaoxing.com/",
                          children: [],
                          logon: true
                        },
                        {
                          label: "退出登录",
                          value: window.location.protocol + "//" + window.location.hostname + "/logout?url=",
                          children: [],
                          logout: true
                        }
                      ]
                    }
                  ],
                  liWidth: 128,
                  activeBorderWidth: 0,
                  activeFontSize: 16,
                  hoverFontSize: 16,
                  hoverIsSameActive: false,
                  hoverBgIsThemeColor: false,
                  navHeight:36
                })
              ]
            }
          ]
        }
      ]
    }).rows
  },
  {
    styleId: 2,
    isSystemComponent: true,
    isDefaultComponent: true,
    isCustomComponent: true, //定制组件
    isIndependenceComponent: true ,//toolbar-option-components 没有单独的设置项
    name: "登录组件",
    width: 200,
    height: 36,
    borderWidth: 0,
    styleName: "自由布局",
    thumbnail: require("../../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["loginLayoutComponent"],
    titleOptions: [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: false,
            type: "classification",
            options: new Tabs({
              elementInLayoutId: 5,
              hoverMaxTabLength: 5,
              tabWidth: 60,
              borderColor: "rgba(255,255,255,1)",
              hoverBorderColor: "rgba(255,255,255,1)",
              tabsList: [
                { name: "未登录", content: "未登录" },
                { name: "登录后", content: "登录后" }
              ]
            })
          },
          {}
        ]
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Button({
                  loginType: "loginBtn",
                  elementInLayoutId: 0,
                  width: 96,
                  height: 36,
                  top: 0,
                  left: 0,
                  content: "登录",
                  iconSrc: "4E6EE877E0E703DD",
                  iconType: "icon",
                  iconColor: "rgba(255,255,255,1)",
                  iconMargin: 6,
                  iconWidth: 18,
                  borderTopLeftRadius: 99,
                  borderTopRightRadius: 99,
                  borderBottomLeftRadius: 99,
                  borderBottomRightRadius: 99
                }),
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Image({
                  loginType: "loginImage",
                  elementInLayoutId: 2,
                  width: 36,
                  height: 36,
                  top: 0,
                  left: 0,
                  borderTypeFlag:1,
                  innerElement: "imageComponent",
                  shapeType: "round",
                  borderRadius:"50%",
                  borderTopLeftRadius: "50%",
                  borderTopRightRadius: "50%",
                  borderBottomLeftRadius: "50%",
                  borderBottomRightRadius: "50%"
                }),
                new navMenu({
                  loginType: "loginName",
                  elementInLayoutId: 4,
                  width: 36,
                  height: 36,
                  navHeight:36,
                  top: 0,
                  left: 0,
                  fontSize: 16,
                  lineHeight: 36,
                  liLineHeight: 36,
                  activeLineHeight: 36,
                  hoverLineHeight: 36,
                  selectFontColor: "rgba(0,0,0,.8)",
                  activeFontColor: "rgba(0,0,0,.8)",
                  hoverFontColor: "rgba(0,0,0,.8)",
                  hoverBgColor: "rgba(0,0,0,0)",
                  activeBgColor: "rgba(0,0,0,0)",
                  selectBgColor: "rgba(0,0,0,0)",
                  topNavPaddingLeft: 0,
                  topNavBgColor: "rgba(255,255,255,0)",
                  bgColor: "rgba(255,255,255,0)",
                  menuOpacity: 0,
                  selectOptions: [
                    {
                      label: "张三",
                      value: "https://www.chaoxing.com/",
                      children: [
                        {
                          label: "进入空间",
                          value: "http://i.chaoxing.com/",
                          children: [],
                          logon: true
                        },
                        {
                          label: "退出登录",
                          value: window.location.protocol + "//" + window.location.hostname + "/logout?url=",
                          children: [],
                          logout: true
                        }
                      ]
                    }
                  ],
                  liWidth: 128,
                  activeBorderWidth: 0,
                  activeFontSize: 16,
                  hoverFontSize: 16,
                  hoverIsSameActive: false,
                  hoverBgIsThemeColor: false,
                  showTopNavIcon: false
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]
/**
 * 大屏文本默认配置数据
 */
export const bs = [{
  styleId: 1,
  name: "登录组件",
  width: 200,
  height: 36,
  borderWidth: 0,
  styleName: "自由布局",
  thumbnail: require("../../../assets/images/leftMenu/layout/layout_1.png"),
  pluginName: ["loginLayoutComponent"],
  titleOptions: [
    {
      type: "top",
      elementOptions: []
    },
    {
      type: "bottom",
      elementOptions: [
        {
          innerElement: "cxTabs",
          isActive: false,
          isShow: false,
          type: "classification",
          options: new Tabs({
            elementInLayoutId: 5,
            hoverMaxTabLength: 5,
            tabWidth: 60,
            borderColor: "rgba(255,255,255,1)",
            hoverBorderColor: "rgba(255,255,255,1)",
            tabsList: [
              { name: "未登录", content: "未登录" },
              { name: "登录后", content: "登录后" }
            ]
          })
        },
        {}
      ]
    },
    {
      type: "left",
      elementOptions: []
    },
    {
      type: "right",
      elementOptions: []
    }
  ],
  rows: new LayoutGenerator({
    rows: [
      {
        height: "100%",
        cols: [
          {
            width: "100%",
            disableSetData: true,
            elementOptions: [
              new Button({
                loginType: "loginBtn",
                elementInLayoutId: 0,
                width: 96,
                height: 36,
                top: 0,
                left: 0,
                content: "登录",
                iconSrc: "4E6EE877E0E703DD",
                iconType: "icon",
                iconColor: "rgba(255,255,255,1)",
                iconMargin: 6,
                iconWidth: 18,
                borderTopLeftRadius: 99,
                borderTopRightRadius: 99,
                borderBottomLeftRadius: 99,
                borderBottomRightRadius: 99
              }),
              // new Button({
              //   loginType: "registerBtn",
              //   elementInLayoutId: 1,
              //   width: 96,
              //   height: 36,
              //   top: 0,
              //   left: 100,
              //   content: "注册",
              //   iconSrc: "4E6EE877E0E703DD",
              //   iconType: "icon",
              //   iconColor: "rgba(255,255,255,1)",
              //   iconMargin: 6,
              //   iconWidth: 18,
              //   borderTopLeftRadius: 99,
              //   borderTopRightRadius: 99,
              //   borderBottomLeftRadius: 99,
              //   borderBottomRightRadius: 99
              // })
            ]
          }
        ]
      },
      {
        height: "100%",
        cols: [
          {
            width: "100%",
            disableSetData: true,
            elementOptions: [
              new Image({
                loginType: "loginImage",
                elementInLayoutId: 2,
                width: 36,
                height: 36,
                top: 0,
                left: 0,
                borderTypeFlag:1,
                innerElement: "imageComponent",
                shapeType: "round",
                borderRadius:"50%",
                borderTopLeftRadius: "50%",
                borderTopRightRadius: "50%",
                borderBottomLeftRadius: "50%",
                borderBottomRightRadius: "50%"
              }),
              new navMenu({
                loginType: "loginName",
                elementInLayoutId: 4,
                width: 128,
                height: 36,
                top: 0,
                left: 44,
                fontSize: 16,
                lineHeight: 36,
                liLineHeight: 36,
                activeLineHeight: 36,
                hoverLineHeight: 36,
                selectFontColor: "rgba(255,255,255,.8)",
                activeTextIsThemeColor: false,
                activeFontColor: "rgba(255,255,255,.8)",
                hoverFontColor: "rgba(255,255,255,.8)",
                hoverBgColor: "rgba(0,0,0,0)",
                activeBgColor: "rgba(0,0,0,0)",
                selectBgColor: "rgba(0,0,0,0)",
                topNavPaddingLeft: 0,
                topNavBgColor: "rgba(255,255,255,0)",
                bgColor: "rgba(255,255,255,0)",
                selectOptions: [
                  {
                    label: "张三",
                    value: "https://www.chaoxing.com/",
                    children: [
                      {
                        label: "进入空间",
                        value: "http://i.chaoxing.com/",
                        children: [],
                        logon: true
                      },
                      {
                        label: "退出登录",
                        value: window.location.protocol + "//" + window.location.hostname + "/logout?url=",
                        children: [],
                        logout: true
                      }
                    ]
                  }
                ],
                liWidth: 128,
                activeBorderWidth: 0,
                activeFontSize: 16,
                hoverFontSize: 16,
                hoverIsSameActive: false,
                hoverBgIsThemeColor: false,
                color: "rgba(255,255,255,0.8)",
                ulBgColor: "#1F2124",
                liFontColor: "rgba(255,255,255,0.8)",
                iconColor: "rgba(255,255,255,0.4)",
                liHoverBgColor: "#1F2124",
                liHoverTextIsThemeColor: false,
                selectBoxShadowColor: ["rgba(0, 0, 0, 0.08", "rgba(255, 255, 255, 0.08)", "rgba(255, 255, 255, 0.12)"],
                navHeight: 50,
              })
            ]
          }
        ]
      }
    ]
  }).rows
},{
  styleId: 2,
  name: "登录组件",
  width: 200,
  height: 36,
  borderWidth: 0,
  styleName: "自由布局",
  thumbnail: require("../../../assets/images/leftMenu/layout/layout_1.png"),
  pluginName: ["loginLayoutComponent"],
  titleOptions: [
    {
      type: "top",
      elementOptions: []
    },
    {
      type: "bottom",
      elementOptions: [
        {
          innerElement: "cxTabs",
          isActive: false,
          isShow: false,
          type: "classification",
          options: new Tabs({
            elementInLayoutId: 5,
            hoverMaxTabLength: 5,
            tabWidth: 60,
            borderColor: "rgba(255,255,255,1)",
            hoverBorderColor: "rgba(255,255,255,1)",
            tabsList: [
              { name: "未登录", content: "未登录" },
              { name: "登录后", content: "登录后" }
            ]
          })
        },
        {}
      ]
    },
    {
      type: "left",
      elementOptions: []
    },
    {
      type: "right",
      elementOptions: []
    }
  ],
  rows: new LayoutGenerator({
    rows: [
      {
        height: "100%",
        cols: [
          {
            width: "100%",
            disableSetData: true,
            elementOptions: [
              new Button({
                loginType: "loginBtn",
                elementInLayoutId: 0,
                width: 96,
                height: 36,
                top: 0,
                left: 0,
                content: "登录",
                iconSrc: "4E6EE877E0E703DD",
                iconType: "icon",
                iconColor: "rgba(255,255,255,1)",
                iconMargin: 6,
                iconWidth: 18,
                borderTopLeftRadius: 99,
                borderTopRightRadius: 99,
                borderBottomLeftRadius: 99,
                borderBottomRightRadius: 99
              }),
            ]
          }
        ]
      },
      {
        height: "100%",
        cols: [
          {
            width: "100%",
            disableSetData: true,
            elementOptions: [
              new Image({
                loginType: "loginImage",
                elementInLayoutId: 2,
                width: 36,
                height: 36,
                top: 0,
                left: 0,
                innerElement: "imageComponent",
                shapeType: "round",
                borderRadius:"50%",
                borderTopLeftRadius: "50%",
                borderTopRightRadius: "50%",
                borderBottomLeftRadius: "50%",
                borderBottomRightRadius: "50%"
              }),
              new navMenu({
                loginType: "loginName",
                elementInLayoutId: 4,
                width: 36,
                height: 36,
                top: 0,
                left: 0,
                fontSize: 16,
                lineHeight: 36,
                liLineHeight: 36,
                activeLineHeight: 36,
                hoverLineHeight: 36,
                selectFontColor: "rgba(255,255,255,.8)",
                activeTextIsThemeColor: false,
                activeFontColor: "rgba(255,255,255,.8)",
                hoverFontColor: "rgba(255,255,255,.8)",
                hoverBgColor: "rgba(0,0,0,0)",
                activeBgColor: "rgba(0,0,0,0)",
                selectBgColor: "rgba(0,0,0,0)",
                topNavPaddingLeft: 0,
                topNavBgColor: "rgba(255,255,255,0)",
                bgColor: "rgba(255,255,255,0)",
                menuOpacity: 0,
                selectOptions: [
                  {
                    label: "张三",
                    value: "https://www.chaoxing.com/",
                    children: [
                      {
                        label: "进入空间",
                        value: "http://i.chaoxing.com/",
                        children: [],
                        logon: true
                      },
                      {
                        label: "退出登录",
                        value: window.location.protocol + "//" + window.location.hostname + "/logout?url=",
                        children: [],
                        logout: true
                      }
                    ]
                  }
                ],
                liWidth: 128,
                activeBorderWidth: 0,
                activeFontSize: 16,
                hoverFontSize: 16,
                hoverIsSameActive: false,
                hoverBgIsThemeColor: false,
                liHoverFontColor: "rgba(255,255,255,.8)",
                color: "rgba(255,255,255,0.8)",
                ulBgColor: "#1F2124",
                liFontColor: "rgba(255,255,255,0.8)",
                iconColor: "rgba(255,255,255,0.4)",
                liHoverBgColor: "#1F2124",
                liHoverTextIsThemeColor: false,
                selectBoxShadowColor: ["rgba(0, 0, 0, 0.08", "rgba(255, 255, 255, 0.08)", "rgba(255, 255, 255, 0.12)"],
                navHeight: 50,
              })
            ]
          }
        ]
      }
    ]
  }).rows
}]
